import React, {ReactNode} from "react";
import {I18nGlobals} from "../../../shared/translation/i18nInterface";
import {ResponsivePie} from "@nivo/pie";
import {PropertyAccessor} from "@nivo/core";
import Translate from "../../../shared/translation/Translate";
import {PieLayer, PieTooltipProps} from "@nivo/pie/dist/types/types";
import {LegendProps} from "@nivo/legends";
import FunctionHelper from "../../../shared/helper/FunctionHelper";
import PortalPureComponent from "../../../shared/components/PortalPureComponent";

interface PieChartProperties extends I18nGlobals {
	data: Array<any>;
	label?: string;
	arcLabel?: PropertyAccessor<any, string>;
	tooltip?: React.FC<PieTooltipProps<any>>;
	legends?: Array<LegendProps>;
	layers?: PieLayer<any>[];
	labelThreshold?: number;
}

interface PieChartState {
}

export class PieChartDefinition extends PortalPureComponent<PieChartProperties, PieChartState> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className="p-col-12 p-lg-6">
				{FunctionHelper.exists(this.props.label) &&
					<h2>{this.props.label}</h2>
				}
				{this.props.data.length === 0 ?
					<p className="no-results">
						<Translate {...this.props} data={"adminscreen.panels.statistics.chart.empty"}
								   namespace={"screen"}/>
					</p> :
					<div style={{height: "500px"}}>
						<ResponsivePie data={this.props.data}
									   colors={{scheme: 'set3'}}
									   tooltip={this.props.tooltip}
									   margin={{top: 60, right: 60, bottom: 60, left: 60}}
									   innerRadius={0.5}
									   sortByValue={true}
									   activeOuterRadiusOffset={8}
									   borderWidth={2}
									   borderColor={{
										   from: "color",
										   modifiers: [
											   [
												   "darker", 0.3
											   ]
										   ]
									   }}
									   layers={this.props.layers}
									   arcLinkLabelsTextColor="#333333"
									   arcLinkLabelsDiagonalLength={30}
									   arcLinkLabelsStraightLength={5}
									   arcLinkLabelsThickness={2}
									   arcLinkLabelsSkipAngle={0}
									   arcLinkLabelsColor={{from: "color", modifiers: []}}
									   arcLabel={this.props.arcLabel}
									   arcLabelsRadiusOffset={0.8}
									   arcLabelsSkipAngle={3.6 * FunctionHelper.applyValue(
										   this.props.labelThreshold, 0
									   )}
									   arcLabelsTextColor="black"
									   isInteractive={true}
									   animate={true}
									   startAngle={-45}
									   endAngle={315}
									   legends={FunctionHelper.applyValue(this.props.legends, [
										   {
											   anchor: "right",
											   direction: "column",
											   justify: false,
											   translateX: 100,
											   translateY: 0,
											   itemsSpacing: 5,
											   itemWidth: 100,
											   itemHeight: 20,
											   itemTextColor: "#999",
											   itemDirection: "left-to-right",
											   itemOpacity: 1,
											   symbolSize: 15,
											   symbolShape: "circle"
										   }
									   ])}
						/>
					</div>
				}
			</div>
		);
	}
}

const PieChart = React.memo(PieChartDefinition,
	(prevProps: Readonly<PieChartProperties>, nextProps: Readonly<PieChartProperties>) => {
		if (prevProps.data !== nextProps.data) {
			return false;
		}

		if (prevProps.language !== nextProps.language) {
			return false;
		}

		if (prevProps.labelThreshold !== nextProps.labelThreshold) {
			return false;
		}

		return true;
	}
);

export default PieChart;